// extracted by mini-css-extract-plugin
export default {"espacamento":"Diaria_espacamento__uB4FM","label":"Diaria_label__-Whvs"};